import Lock from '@/assets/icons/common/lockSecurity.svg';
import { CheckoutContext } from '@/context/CheckoutContext';
import { generateZendeskSupportURL } from '@/utils/support';
import { useContext } from 'react';
import { useTranslate } from '@/hooks/useTranslate';
import { Divider } from '../Common/Divider';
import { PoweredByAppcharge } from './PoweredByAppcharge';

export const Footer = () => {
  const { customer, publisherId } = useContext(CheckoutContext);
  const { t } = useTranslate();

  return (
    <div className="w-full">
      <Divider />
      <div className="w-full flex flex-col items-center justify-center gap-1 md:gap-2 mt-auto mb-5">
        <PoweredByAppcharge />
        <div className="flex flex-col items-center justify-center gap-2">
          <div className="flex flex-row items-center justify-center gap-2">
            <img src={Lock} alt="lock" className="w-4 h-4" />
            <div className="text-xs text-muted-foreground">{t('dataSecurity')}</div>
          </div>
          <div className="flex items-center justify-center gap-2 text-xs text-muted-foreground">
            <a href="https://appcharge.com/payments-privacy-policy/" target="_blank" rel="noopener noreferrer">
              {t('privacyPolicy')} |
            </a>
            <a href="https://appcharge.com/refund-policy/" target="_blank" rel="noopener noreferrer">
              {t('refundPolicy')} |
            </a>
            <a
              href={generateZendeskSupportURL({
                customerId: customer?.id,
                orderId: '',
                publisherId,
                customerCountryCode: customer?.geoLocator?.countryCode2,
              })}
              target="_blank"
              rel="noopener noreferrer"
            >
              {t('support')}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
